module.exports = __webpack_public_path__ + "media/images/top/idea-item04-9647e8c2a0a07ae6de0d232c57bb6ea7.webp";